import React from 'react';
import { Hash } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface ScoreCardIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const ScoreCardIcon: React.FC<ScoreCardIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <Hash size={size} color={color} />
        </IconWrapper>
    );
};
